import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID",
  title: defineMessage({
    id: "fig.finance.AID.title",
    defaultMessage: `Aid to education by level`,
  }),
  caption: defineMessage({
    id: "fig.finance.AID.caption",
    defaultMessage: `Aid to education has been stagnant and unpredictable since the financial crisis.`,
  }),
  source: defineMessage({
    id: "fig.finance.AID.source",
    defaultMessage: `GEM Report team analysis based on OECD CRS`,
  }),
};
